import styled from 'styled-components';

import { Link } from 'app/shared/ui';

export const CartileLinkBackgroundSt = styled(Link)`
  display: block;
  width: 100%;
  height: 100%;
`;
